
const AciAirApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/get`,
  POST: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/create`,
  PUT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/update`,
  DELETE: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/delete`,
  DELETE_ALL: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/deleteAll`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/download`,
  CLONE: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/clone`,
  SUBMIT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/submit`,
  SUBMIT_ALL: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/s10/submitAll`,
  SEARCH: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/aci-air-search/get`
};

export default AciAirApiUrls
